// @ts-nocheck
import React from "react";
import { Col, Row, Form, Button, Tooltip, Radio, Space, message, Select } from "antd";
import "../oneONone.css"
import close from '../../assets/close.svg'
import moment from 'moment-timezone';
import { DatePickerField, displayUtcToUserTimezone, SelectField, TextField } from "../../look";
const OccuranceView = props => {
    const { type, onClose, changeRule, when, selected_end_date } = props
    const [occurance_type, set_occurance_type] = React.useState()
    const [start_date, setstart_date] = React.useState();
    const [end_date, setend_date] = React.useState();
    const [weekdays, setweekdays] = React.useState([]);
    const [monthlyvalue, setmonthlyvalue] = React.useState(1);
    const [form] = Form.useForm();
    const [monthlyForm] = Form.useForm();
    const [info, setinfo] = React.useState()
    const { Option } = Select;
    React.useEffect(() => {
        if (type) {
            set_occurance_type(type?.type)
            if (type?.days) {
                setweekdays(type?.days)
            } else {
                let list = { 0: 'SU', 1: 'MO', 2: 'TU', 3: 'WE', 4: 'TH', 5: 'FR', 6: 'SA' }
                let day = new Date().getDay()
                setweekdays([list[day]])
            }
        }
    }, [type])

    React.useEffect(() => {
        generateInfo(start_date, { type: occurance_type, days: weekdays }, end_date)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthlyvalue])

    React.useEffect(() => {
        if (when) {
            setstart_date(when)
        }
    }, [when])

    React.useEffect(() => {
        if (when && type) {
            let list = { 0: 'SU', 1: 'MO', 2: 'TU', 3: 'WE', 4: 'TH', 5: 'FR', 6: 'SA' }
            let day = new Date().getDay()
            generateInfo(when, { ...type, days: type?.days || [list[day]] })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [when, type])

    const generateInfo = (start_date, oc_type, end_date) => {
        let values = form.getFieldsValue()
        let monthform = monthlyForm.getFieldsValue()
        if (oc_type?.type === 'Day') {
            let info = `occurs every ${values?.repeat > 1 ? `${values?.repeat} days` : 'day'} starting ${displayUtcToUserTimezone(start_date, "YYYY/MM/DD")} ${end_date ? `until ${displayUtcToUserTimezone(end_date, "YYYY/MM/DD")}` : ''}`
            setinfo(info)
        } else if (oc_type?.type === 'Week') {
            let days_list
            if (oc_type?.days) {
                let x = weekday_list?.filter(item => oc_type?.days?.includes(item?.value)).sort((a, b) => a?.order - b?.order)
                days_list = x?.map(value => value?.label)?.join(',')
            }

            let info = `occurs every ${days_list} starting ${displayUtcToUserTimezone(start_date, "YYYY/MM/DD")} ${end_date ? `until ${displayUtcToUserTimezone(end_date, "YYYY/MM/DD")}` : ''}`
            setinfo(info)
        }
        else if (oc_type?.type === 'Month') {
            let info
            if (monthlyvalue === 1) {
                info = monthform?.day ? `occurs every month on day ${monthform?.day} starting ${displayUtcToUserTimezone(start_date, "YYYY/MM/DD")} ${end_date ? `until ${displayUtcToUserTimezone(end_date, "YYYY/MM/DD")}` : ''}` : ''
            } else {
                let data
                let a = day_count?.find(item => item?.value === monthform?.day_count)
                let b = weekday_list?.find(item => item?.value === monthform?.week_date)
                if (a && b) {
                    data = `${a?.label} ${b?.label}`
                }
                info = (monthform?.day_count && monthform?.week_date) ? `occurs every month on ${data} starting ${displayUtcToUserTimezone(start_date, "YYYY/MM/DD")} ${end_date ? `until ${displayUtcToUserTimezone(end_date, "YYYY/MM/DD")}` : ''}` : ''
            }
            setinfo(info)
        }
    }

    const ref = React.useRef(null);

    const save = () => {
        let values = form.getFieldsValue();
        let monthform = monthlyForm.getFieldsValue();

        if ((!end_date && !selected_end_date) || !start_date || !end_date) {
            message.error('Select dates');
            return;
        }

        if (!values?.repeat) {
            message.error('Set proper interval');
            return;
        }
        const start = moment(start_date);
        const end = moment(end_date || selected_end_date);

        // MONTHLY CHECK
        if (values?.type === 'Month') {


            const dayOfMonth = Number(monthform?.day);
            let testDate = moment(start).date(dayOfMonth);

            // Make sure testDate stays in the same month and within range
            if (testDate.month() !== start.month() || testDate.isBefore(start) || testDate.isAfter(end)) {
                const nextMonth = moment(start).add(1, 'month');
                testDate = moment(nextMonth).date(dayOfMonth);
                if (testDate.month() !== nextMonth.month() || testDate.isAfter(end)) {
                    message.error('Selected monthly date does not occur in the valid range');
                    return;
                }
            }
        }

        // WEEKLY CHECK
        if (values?.type === 'Week') {
            const selectedDays = weekdays || []; // ['MO', 'WE', etc.]
            let hasValidWeekday = false;

            for (let d = moment(start); d.isSameOrBefore(end); d.add(1, 'day')) {
                const weekday = d.format('dd').toUpperCase(); // 'MO', 'TU', etc.
                if (selectedDays.includes(weekday)) {
                    hasValidWeekday = true;
                    break;
                }
            }

            if (!hasValidWeekday) {
                message.error('Selected weekdays do not occur in the date range');
                return;
            }
        }
        const checkOccurrenceExists = () => {
            const dayCount = monthform?.day_count;  // '1', '2', '3', '4', or 'L'
            const weekDay = monthform?.week_date;   // 'MO', 'TU', etc.
            const start = moment(start_date).startOf('day'); // Normalize to start of day
            const end = moment(end_date).endOf('day');

            if (!dayCount || !weekDay) {
                message.error('Please select both day position and weekday');
                return false;
            }

            // Convert weekday string to moment's day number
            const weekDayMap = { 'SU': 0, 'MO': 1, 'TU': 2, 'WE': 3, 'TH': 4, 'FR': 5, 'SA': 6 };
            const targetDay = weekDayMap[weekDay];

            // Check each month in the range
            let currentMonth = start.clone().startOf('month');
            const endMonth = end.clone().startOf('month');

            while (currentMonth.isSameOrBefore(endMonth)) {
                let occurrence;

                if (dayCount === '-1') {
                    // Last occurrence - find last weekday in month
                    occurrence = currentMonth.clone().endOf('month');
                    // Go backwards to the previous target weekday
                    while (occurrence.day() !== targetDay) {
                        occurrence.subtract(1, 'day');
                    }
                } else {
                    // Nth occurrence
                    const n = parseInt(dayCount);
                    let count = 0;
                    occurrence = currentMonth.clone().startOf('month').day(targetDay);

                    // Adjust if first occurrence is in previous month
                    if (occurrence.month() !== currentMonth.month()) {
                        occurrence.add(7, 'days');
                    }

                    // Find the nth occurrence
                    while (count < n && occurrence.month() === currentMonth.month()) {
                        count++;
                        if (count === n) break;
                        occurrence.add(7, 'days');
                    }

                    // If we didn't find n occurrences, skip this month
                    if (count < n) {
                        currentMonth.add(1, 'month');
                        continue;
                    }
                }

                // Check if found occurrence is within date range
                if (occurrence.isSameOrAfter(start) && occurrence.isSameOrBefore(end)) {
                    return true;
                }

                // Move to next month
                currentMonth.add(1, 'month');
            }

            message.warning('This pattern does not occur between the selected dates');
            return false;
        };

        // Usage in your save function:
        if (values?.type === 'Month' && monthlyvalue === 2) {
            if (!checkOccurrenceExists()) {
                return; // Don't proceed if no occurrences exist
            }
            // Continue with RRULE generation...
        }


        let rrule;
        let until = end_date ?
            moment(end_date).endOf('day').utc().toISOString().replaceAll(':', '').replaceAll('-', '').split('.')[0] + 'Z' :
            moment(selected_end_date).endOf('day').utc().toISOString().replaceAll(':', '').replaceAll('-', '').split('.')[0] + 'Z';

        if (values?.type === 'Week') {
            rrule = `RRULE:FREQ=WEEKLY;INTERVAL={intervel};BYDAY=${weekdays?.join(',')};UNTIL={until}`;
        }
        else if (values?.type === 'Month') {
            if (monthlyvalue === 1) {
                if (!monthform?.day) {
                    message.error('Set proper date');
                    return;
                }
                rrule = `RRULE:FREQ=MONTHLY;INTERVAL={intervel};BYMONTHDAY=${monthform?.day};UNTIL={until}`;
            }
            else {
                // Make sure we're using the values from monthlyForm

                if (!monthform?.day_count || !monthform?.week_date) {
                    message.error('Set proper day pattern');
                    return;
                }
                rrule = `RRULE:FREQ=MONTHLY;INTERVAL={intervel};BYDAY=${monthform?.day_count}${monthform?.week_date};UNTIL={until}`;
            }
        }
        else if (values?.type === 'Day') {
            rrule = `RRULE:FREQ=DAILY;INTERVAL={intervel};UNTIL={until}`;
        }

        rrule = rrule?.replace('{intervel}', values?.repeat);
        rrule = rrule?.replace('{until}', until);
        changeRule({ rrule, info, start_date, end_date });
    }

    const weekday_list = [
        { value: 'SU', name: 'S', label: "Sunday", order: 0 },
        { value: 'MO', name: 'M', label: "Monday", order: 1 },
        { value: 'TU', name: 'T', label: "Tuesday", order: 2 },
        { value: 'WE', name: 'W', label: "Wednesday", order: 3 },
        { value: 'TH', name: 'T', label: "Thursday", order: 4 },
        { value: 'FR', name: 'F', label: "Friday", order: 5 },
        { value: 'SA', name: 'S', label: "Saturday", order: 6 },]

    const day_count = [{ value: "1", label: "First" }, { value: "2", label: "Second" }, { value: "3", label: "Third" }, { value: "4", label: "Fourth" }, { value: "-1", label: "Last" }]

    const changeDay = (e) => {
        let list = [].concat(weekdays)
        if (list.find(item => item === e)) {
            if (list?.length > 1) {
                list = list?.filter(i => i !== e)
            }
        } else {
            list.push(e)
        }
        generateInfo(start_date, { type: occurance_type, days: list }, end_date)
        setweekdays(list)
    }



    return (
        <>
            {occurance_type && (
                <>
                    <div className="row space-between aligin-center">
                        <div style={{ width: "10px", height: "5px" }}></div>
                        <h4 className="occarance-modal-title">Set recurrence</h4>
                        <img src={close} alt="" className="close-icon" onClick={() => { onClose() }} />
                    </div>
                    {/* border: !dateInvalid ? '' : '1px solid #ff4d4f' */}
                    <Row style={{ marginTop: "20px" }}>
                        <Col span={12}>
                            <p style={{ fontSize: '15px' }}><span style={{ color: '#ff4d4f' }}>*</span> Start date</p>
                            <DatePickerField
                                ref={ref}
                                style={{ width: '100%', height: '36px', }}
                                format="YYYY-MM-DD"
                                dropdownClassName="modal-datepicker-index"
                                onChange={e => { (e ? setstart_date(e) : setstart_date(null)); generateInfo(e, { type: occurance_type, days: weekdays }, end_date) }}
                                disabledDate={(current) => current < moment().subtract(1, 'day') || current > moment(end_date)}
                                allowClear={false}
                                defaultValue={moment(when)}
                            //   disabled={!end_date}
                            //   showTime={{ 
                            //     format: 'HH:mm',
                            //  }}
                            // defaultValue={moment(when)}
                            //   disabledTime={e=>disabledRangeTime(e)}
                            />
                        </Col>
                        <Col span={12}>
                            <p style={{ fontSize: '15px' }}><span style={{ color: '#ff4d4f' }}>*</span> End date</p>
                            <DatePickerField
                                ref={ref}
                                style={{ width: '100%', height: '36px', }}
                                format="YYYY-MM-DD"
                                dropdownClassName="modal-datepicker-index"
                                disabled={!start_date}
                                onChange={e => { (e ? setend_date(e) : setend_date(null)); generateInfo(start_date, { type: occurance_type, days: weekdays }, e) }}
                                disabledDate={(current) => current < moment(start_date) || current > moment(start_date).add(1, "year")}
                                allowClear={false}
                                defaultValue={undefined}
                            //   showTime={{ 
                            //     format: 'HH:mm',
                            //  }}
                            // defaultValue={moment(when)}
                            //   disabledTime={e=>disabledRangeTime(e)}
                            />
                        </Col>
                    </Row>
                    <Col span={12}>
                        <p style={{ fontSize: '15px' }}>Repeat Every</p>
                        <Form
                            initialValues={{ repeat: 1, type: occurance_type }}
                            form={form}
                            key={Math.random()}
                        >
                            <Row wrap={false}>
                                <TextField type='number' margin="0px" onChange={() => { generateInfo(start_date, { type: occurance_type, days: weekdays }, end_date) }} style={{ width: '70px' }} widthscale="80px" minValue={1} maxValue={365} name="repeat" />
                                <SelectField
                                    name="type"
                                    onChange={(e) => { set_occurance_type(e); generateInfo(start_date, { type: e, days: weekdays }, end_date) }}
                                    style={{ width: "100px" }}
                                    choices={[{ value: "Day", label: "Day" }, { value: "Week", label: "Week" }, { value: "Month", label: "Month" }]}
                                />
                            </Row>
                        </Form>
                    </Col>
                    {
                        occurance_type === 'Week' ?
                            <div className="occurance-row" >
                                {
                                    weekday_list?.map(item => (
                                        <Tooltip title={item?.label}>
                                            <Button onClick={() => { changeDay(item?.value) }} className={`day-btn ${weekdays?.includes(item?.value) ? 'active-day-btn' : ''}`}>{item?.name}</Button>
                                        </Tooltip>
                                    ))
                                }
                            </div> : ''
                    }

                    {
                        occurance_type === 'Month' ?
                            <Form
                                // initialValues={getinitialMonthValue()}
                                form={monthlyForm}
                                key={Math.random()}
                            >
                                <Radio.Group onChange={(e) => setmonthlyvalue(e?.target?.value)} name="selection" value={monthlyvalue}>
                                    <Space direction="vertical">
                                        <Radio value={1}>
                                            <div style={{ display: 'flex', flexDirection: "row", gap: "10px", justifyContent: 'start', alignItems: "center" }}>
                                                <p style={{ margin: '0px', marginTop: "-30px" }}>On day</p>
                                                <TextField type='number' disabled={monthlyvalue !== 1} placeholder=' ' onChange={(e) => generateInfo(start_date, { type: occurance_type, days: weekdays }, end_date)} margin="0px" style={{ width: '70px' }} widthscale="80px" minValue={1} maxValue={31} name="day" />
                                            </div>
                                        </Radio>
                                        <Radio value={2}>
                                            <div style={{ display: 'flex', flexDirection: "row", gap: "10px", justifyContent: 'start', alignItems: "center" }}>
                                                <p style={{ margin: '0px', marginTop: "0px" }}>On the</p>
                                                <Form.Item name="day_count" noStyle>
                                                    <Select
                                                        disabled={monthlyvalue !== 2}
                                                        className="occurance_dropdown"
                                                        onChange={() => generateInfo(start_date, { type: occurance_type, days: weekdays }, end_date)}
                                                        style={{ width: "120px" }}>
                                                        {day_count && day_count?.map((choice, key) => (
                                                            <Option key={key} value={choice.value}>
                                                                {choice.label}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>

                                                <Form.Item name="week_date" noStyle>
                                                    <Select
                                                        disabled={monthlyvalue !== 2}
                                                        className="occurance_dropdown"
                                                        onChange={() => generateInfo(start_date, { type: occurance_type, days: weekdays }, end_date)}
                                                        style={{ width: "120px", marginLeft: "10px" }}>
                                                        {weekday_list && weekday_list?.map((choice, key) => (
                                                            <Option key={key} value={choice.value}>
                                                                {choice.label}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </Radio>
                                    </Space>
                                </Radio.Group>
                            </Form> : ''
                    }
                    <div align="center">
                        <p style={{ marginTop: "20px" }}>{info}</p>
                    </div>
                    <div align="end">
                        <Button className="occurance-save" onClick={() => { save() }}>Save</Button>
                    </div>
                </>

            )}

        </>
    )
}
export default OccuranceView